import type { FunctionComponent } from 'react';
import { useMemo } from 'react';

import { Divider } from '../../../shared/components/divider/divider';
import { useDemographicsFilter } from '../../../shared/hooks/demographic';
import { createClassName, createStyleHelper } from '../../../shared/utils/class-names';
import { exists } from '../../../shared/utils/filters';
import type { FooterSections } from '../../footer.interface';
import type { IFooterCollection } from '../../queries/footer.graphql';
import { FooterItem } from '../footer-item/footer-item';

import styles from './footer-section.module.scss';

const style = createStyleHelper(styles, 'footer-section');

export interface IFooterProps {
    className?: string;
    footerItems?: IFooterCollection[];
    displaySection?: FooterSections;
    withEndDivider?: boolean;
}
//footer

export const FooterSection: FunctionComponent<IFooterProps> = ({
    className,
    footerItems,
    displaySection,
    withEndDivider = false,
}) => {
    const displayItems = useMemo(
        () =>
            footerItems?.find((item) => {
                return item.type === displaySection;
            }),
        [displaySection, footerItems],
    )?.items;

    const filteredDisplayItems = useDemographicsFilter(displayItems?.filter(exists) ?? []);

    if (!filteredDisplayItems) {
        return null;
    }

    return (
        <div className={createClassName([className, style()])}>
            <nav className={style('sections')}>
                {filteredDisplayItems?.map((item) => {
                    return <FooterItem key={item?.id} displayItem={item} />;
                })}
            </nav>
            {withEndDivider ? <Divider /> : null}
        </div>
    );
};
